module.exports = __webpack_public_path__ + "static/assets/7c6f2c04b962b68adfcc0e2368e3ff38.png";